<template>
  <section class="new-apply-header">
    <div class="progress">
      <template v-for="(item, index) in stepText">
        <div class="step" :class="{'none':(index + 1) !== step && (step - index) < 2, 'ing': (index + 1) === step, 'done': (index + 1) !== step && (step - index) >= 2}" :key="index">
          <span class="text">{{ item }}</span>
        </div>
        <div class="line" :class="{'done': (index + 1) !== step && (step - index) >= 2}" v-if="index<stepText.length-1" :key="index+'dot'"></div>
      </template>
    </div>
  </section>
</template>

<script>
// config
// import ETC from '@/config/etc.config'

export default {
  name: 'newApplyHeader',
  components: {},
  props: {
    page: {
      type: String
    },
    currentStep: {
      type: [String, Number],
      default: '1'
    }
  },
  data() {
    return {}
  },
  computed: {
    stepText() {
      // todo 招行保证金
      if (this.appChannel === 'zhaohang') return [ '开始办理', '绑定一网通支付', '上传资料' ]
      // if (this.appChannel === 'zhaohang') return ['绑定一网通支付', '缴纳保证金', '上传资料']
      return ['支付成功', '上传资料', '绑定微信支付']
    },
    step() {
      return Number(this.currentStep)
    }
  },
  methods: {
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.new-apply-header{
  .progress{
    background-color: #001D2C;
    padding: 0 45px 30px;
    height: 150px;
    @extend %flex-center;
    color: #FFFFFF;
    .step{
      width: 20px;
      height: 20px;
      position: relative;
      box-sizing: content-box;
      color: #666666;
      border-radius: 50%;
      margin: 0 10px;
      .text{
        position: absolute;
        font-size: 28px;
        white-space: nowrap;
        top: 30px;
        left: 50%;
        transform: translateX(-50%);
      }
      &.done{
        background-color: $primary-color;
      }
      &.ing{
        background-color: $primary-color;
        border: 8px solid #4D616B;
        color: #FFFFFF;
        &:after{
          content: '';
          width:0;
          height:0;
          border-width:0 18px 18px;
          border-style:solid;
          border-color:transparent transparent #FFFFFF;/*透明 透明  灰*/
          position:absolute;
          z-index: 2;
          bottom: -82px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      &.none{
        background-color: #666666;
      }
    }
    .line{
      width: 200px;
      height: 2px;
      background-color: #fff;
      opacity: .1;
      &.done{
        background-color: $primary-color;
        opacity: 1;
      }
    }
  }
}
</style>
